<!-- eslint-disable no-unused-vars -->
<template>
    <div class="carrinho-body">
        <!-- ---------------------------------------------- caso esteja no loading --------------------------------------------------------  -->
        <div v-if="loading" class="loading">
            <img src="../assets/loading.gif" alt="" style="height: 45px" /> 
        </div>

        <div v-if="!loading" style="height: 90vh; overflow-y: scroll;">


            <div>
                <TituloDePaginaView  :titulo="'CARRINHO'"  :cor="'black'">
                    <img class="icone_do_carrinho" src="../assets/icons/ic-carrinho.png"/>
                </TituloDePaginaView>
            </div>

            <div v-if="habilitarQrcodeScanner">
                <CameraScanner @onBarcodeLido="onBarcodeLido"/>    
            </div>

            <!-- ---------------------------------------------- itens do carrinho (caso a camera nao esteja aberta) --------------------------------------------------------  -->
            <div v-if="!habilitarQrcodeScanner" style=" background-color: transparent ; height: fit-content; margin-bottom: 200px; ">
                
                <lista-itens-carrinho   
                :carrinho="carrinho" 
                :semItensNoCarrinho="!podeEnviar"
                :deletarItem="deletarItem"
                :deletarItemCombo="deletarItemCombo"
                :editarItem="editarItem"
                :editarItemCombo="editarItemCombo"
                />
            </div>
            
        </div>



        <!-- ---------------------------------------------------------------------------------- bottom bar ------------------------------------------------------------------  -->

    </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import axios from "axios";
import { mapGetters } from "vuex";
// eslint-disable-next-line no-unused-vars
import { rotaDeProducao } from "../api/rotas";
import Swal from "sweetalert2";
import { apiSincronizacao } from "@/api/ApiSincronizacao";
import { setarCores } from '@/utils/SetarCores';
// import CardItemCarrinho from '@/components/Carrinho/CardItemCarrinho.vue';
// import { controlePedirNumeroCartao } from '@/components/Controle/pedirNumeroCartao';
import { CONSOLOGAR } from '@/components/Controle/debug';
// eslint-disable-next-line no-unused-vars
import { apiAbriuTelaConta, apiBuscarItensDaConta, apiBuscarStatusMesa, apiFechouTelaConta } from '@/api/ApiPegarMesa';
import ListaItensCarrinho from "../components/Carrinho/ListaItensCarrinho.vue"
// import BottomBarCarrinho from "../components/Carrinho/BottomBarCarrinho.vue"
import PedidoModel from "@/model/pedidoModel";
import TituloDePaginaView from "../components/Base/TituloDePagina.vue"
import { controleConfirmarNumeroCartao } from '@/components/Controle/pedirNumeroCartao';
// import { apiChamarGarcom } from '@/api/ApiChamarGarcon';
import CameraScanner from "@/utils/CameraScanner.vue";
import { gerarIdUnico } from "@/utils/GerarIdUnico";

// import { CONSOLOGAR } from '@/components/Controle/debug';

/**
 * Aqui estao os itens adicionados ao carrinho.
 *
 * @vue-data {Array} [precoTotalItem=[]] array de cada item com objs do id do item e o preco final
 * @vue-data {Double} [precoFinal=0] entra no array do precoTotalItem e é a soma dos itens de um combo
 * @vue-data {Double} [precoTotalFinal=0]
 * @vue-data {Boolean} [disabled=false]
 * @vue-data {Boolean} [podeEnviar=true] aponta se o botao enviar do carrinho vai estar enabled ou disabled
 * @vue-data {Boolean} [loading=false] vai apontar se deve mostrar o gif de loading ou nao
 * @vue-data {Boolean} [animarTextoDesabilidado=false] anima o texto para mostrar que o botao enviar esta desabilitado
 *
 * @vue-computed {Double} getFinalTotal retorna o preco total de todos os itens do carrinho
 *
 * @vue-watch getFinalTotal inicia o getFinalTotal no computed assim que a tela renderiza
 */
export default {
    name: "CarrinhoView",

    data() {
        return {
            abaLocal: this.$store.state.abaSelecionada,
            precoTotalItem: [],
            precoFinal: 0,
            precoTotalFinal: 0,
            disabled: false,
            podeEnviar: true,
            loading: false,
            animarTextoDesabilidado: false,
            numeroComanda: null,
            //
            clicouEnviar: this.$store.state.onClickEnviarPedido,
            deliveryValorMinimo: this.$store.state.deliveryValorMinimo,
            habilitarQrcodeScanner: false,
            // produtos:this.$store.state.produtos,
        }
    },

    computed: {
        ...mapGetters({
            carrinho: "getItensCarrinho",
        }),

        getFinalTotal: function () {
            return this.calcularValorTotalFinal().toFixed(2).replace(".", ",").replace(".", ",");
        },
    },

    created() {
        this.calcularPrecosItens();
        this.setarPodeEnviar();
        setarCores(this.$store.state.cor1, this.$store.state.cor2, this.$store.state.corTexto);
    },

    components: {
        ListaItensCarrinho,TituloDePaginaView,
        CameraScanner,
    },
    watch: {
        /** calcula o total final assim que a tela renderiza */
        getFinalTotal() {
            if (this.getFinalTotal == 0.0) {
                this.podeEnviar = false;
            }
        },

        /** vamos ouvir se a var {onClickEnviarPedido} mudou. Se ela mudou, eh pq o usuario clicou em enviar pedido */
        '$store.state.onClickEnviarPedido': function() {
            this.onClickConfirmar()
        },
    },
    methods: {
       
        mudarParaCardapio() {
            const novaAba = "cardapio";
            this.$store.dispatch('setAbaSelecionada', novaAba);
            this.abaLocal = novaAba;
        },

        limparCarrinhoDebug() {
            this.$store.commit('SET_LIMPAR_ITENS_CARRINHO')
        },

        calcularValorTotalFinal() {
            console.log("checando valores do carrinho")
            console.log(this.carrinho)
            let finalPrecoTotal = 0.0;
            for (var i = 0; i < this.carrinho.length; i++) {
                finalPrecoTotal = finalPrecoTotal + parseFloat(this.carrinho[i].precoTotal) * this.carrinho[i].quantidade;
            }
            return finalPrecoTotal;
        },

        /**
         * vai alterar a var podeEnviar para true ou false dependendo do getFinalTotal
         * @see podeEnviar
         * @see getFinalTotal
         */
        setarPodeEnviar() {
            if (this.carrinho == null || this.carrinho.length == 0) {
                this.podeEnviar = false;
            } else {
                this.podeEnviar = true;
            }
        },

        /** deleta item do carrinho e verificar se o carrinho esta vazio */
        deletarItem(item) {
            this.$store.dispatch("setDeletarItemCarrinho", item);
            this.disabled = true;
            setTimeout(() => {
                this.disabled = false;
            }, 1500);
            this.setarPodeEnviar();
        },

        editarItem(item) {
            // Deleta o item do carrinho
            this.deletarItem(item);
            
            console.log(`item editado: `, item)
            this.$store.dispatch("setItemSelecionado", item.item);
            
            // Navega para a página do item (considerando menu estático ou não)
            if (this.$store.state.isMenuEstatico) {
                this.$router.push({
                    name: "menu-estatico-item",
                    params: {
                        item: item,
                        id: item.id,
                    },
                });
            } else {
                this.$router.push({
                    name: "item",
                    params: {
                        item: item,
                        id: item.id,
                        atributoAnteriorCasoItemEditado: {
                            quantidade: item.quantidade,
                            itensAdicionar: item.adicionar,
                            itemsRetirar: item.retirar,
                            perguntasForcadas: item.perguntasForcadas,
                        }
                    },
                });
            }
            this.disabled = true;
            setTimeout(() => {
                this.disabled = false;
            }, 1500);
            this.setarPodeEnviar();
        },
        // buscar o item pelo id para depois editar o combo, em todos os itens de todas as classes do cardapio
        buscarProdutosPeloId(id) {
            let produtos=this.$store.state.produtos
            
            if (id === null || id === undefined) {
                return null;
            }
            for (const produto of produtos) {
                if (!produto || !produto.itensVenda) {
                    continue;
                }
                const encontrado = produto.itensVenda.find((item) => item && item.id == id);
                if (encontrado) {
                    return encontrado;
                }
            }

            return null;
        },
        editarItemCombo(combo) {
            let buscarItem = this.buscarProdutosPeloId(combo.id);
            // Deleta o item do carrinho
            this.deletarItem(combo);

            console.log(`item editado combo: `, combo)
            //muda o item que vai aparecer no /item
            this.$store.dispatch("setItemSelecionado", buscarItem);
            
            if(buscarItem){
                if (this.$store.state.isMenuEstatico) {
                    this.$router.push({
                        name: "menu-estatico-item",
                        params: {
                            item: combo,
                            id: combo.id,
                        },
                    });
                } else {
                    this.$router.push({
                        name: "item",
                        params: {
                            item: buscarItem,
                            id: buscarItem.id,
                            atributoAnteriorCasoItemEditado:combo
                        },
                    });
                }
                this.disabled = true;
                setTimeout(() => {
                    this.disabled = false;
                }, 1500);
                this.setarPodeEnviar();
            }
            else {
                console.log("nao encontrou o item para editar o combo")
            }
        },

        /** deletar item do combo tem que deletar o combo todo  */ 
        deletarItemCombo(combo) {
            if(combo.subitens.length===1){//Se o combo tem apenas 1 subitem ele se comporta como um produto/mercadoria e deleta sem perguntar.
                this.deletarItem(combo)
            }
            else {
                Swal.fire({
                    title:combo.tipo==="comboPizza"?"EXCLUIR PIZZA":"EXCLUIR COMBO", 
                    text:combo.tipo==="comboPizza"?"A exclusão de um item da PIZZA (como sabor, borda ou massa) remove toda a pizza do carrinho. Deseja continuar?"
                    :"A exclusão de um item do COMBO remove todos os itens do combo do carrinho. Deseja continuar?", 
                    showCancelButton: true,
                    reverseButtons: true,
                    cancelButtonText: "NÃO",
                }).then((result) => {
                    // clicou em sim
                    if (result.isConfirmed) { 
                        this.deletarItem(combo)
                    }
                    // clicou em nao = result.isDismissed
                })
            }


        },

        /** calcula o preco dos itens */
        calcularPrecosItens() {
            console.log("------------------------------------------------------------------------------------------------")
            //mudou para carrinho
            this.$store.dispatch("startIdUnicoDoPedido")
            console.log(this.$store.state.idUnicoPedido)
            for (var i = 0; i < this.carrinho.length; i++) {
                let preco = 0;
                let preco2 = 0;
                let preco3 = 0;
                preco = preco + parseFloat(this.carrinho[i].preco);

                // so calcular as etapas caso o item tenha etapas ( etapas != undefined )
                if (this.carrinho[i].etapas != undefined) {
                    for (
                        var ii = 0;
                        ii < this.carrinho[i].etapas.length;
                        ii++
                    ) {
                        preco2 =
                            preco2 +
                            parseFloat(this.carrinho[i].etapas[ii].preco);
                        for (
                            var iii = 0;
                            iii < this.carrinho[i].etapas[ii].escolha.length;
                            iii++
                        ) {
                            preco3 =
                                preco3 +
                                parseFloat(this.carrinho[i].etapas[ii].preco);
                        }
                    }
                }

                this.precoFinal = preco + preco2 + preco3;
                this.precoTotalItem.push({
                    itemId: this.carrinho[i].id,
                    precoFinal: this.precoFinal,
                });
            }
        },

        /** volta para a tela de escolha de itens */
        voltar() {
            this.$router.back(); 
        },

        /**
         * retorna data formatada para verificar se a promocao ainda esta valida
         * @returns {string} data formatada "2024-12-12 06:35:00"
         */
         getFormattedDate() {
            const now = new Date();

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const day = String(now.getDate()).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');
            const seconds = String(now.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },

        /**
         * vai montar o pedido em formato json e sera usado na funcao finalizarPedido.
         *
         * Traz do store os dados de numeroEmpresaFK, idgarcom, codigoCentroResultado, itensCarrinho e numero da mesa
         * @see {@link this.finalizarPedido()}
         */
        montarJsonDoPedido() {
            let tipo = this.$store.state.porCartao ? "cartao" : "mesa"
            let json = new PedidoModel();

            json.idUnico = gerarIdUnico();
            
            json.tipo = tipo;
            json.isMenuEstatico = this.$store.state.isMenuEstatico;
            json.mesa = this.$store.state.mesa;
            json.cartao = this.numeroComanda;
            // json.valorTotalCarrinho = this.getFinalTotal;
            json.cnpj = this.$store.state.cnpj;
            json.numeroEmpresaFK = this.$store.state.numeroEmpresaFK;
            json.IdGarcons_FK = this.$store.state.idgarcom;
            json.idTerminal = this.$store.state.idTerminal;
            json.numeroComanda = this.numeroComanda;
            json.CodigoCentroResultado_FK = this.$store.state.codigoCentroResultado;
            json.itens = this.$store.state.itensCarrinho;
            json.isHardRock = this.$store.state.isHardRock;
            json.valorTotalCarrinho = this.calcularValorTotalFinal();

            json.horarioCompra = this.getFormattedDate() // para ver se a promocao ainda vaale. Formato: "2024-12-12 06:35:00"
            
            return json;
        },

        /** caso o a empresa trabalhe por comanda, pedir o numero da comanda */
        async onClickConfirmar() {
            const temAlergia = await this.perguntarAlergia()
            console.log(temAlergia.isConfirmed )
            
            // caso nao tenha alergia, ou nao seja hard rock, seguir com o pedido normalmente
            if (temAlergia.isConfirmed == false ) {
                console.log("proseguir de boa")

                let porCartao = this.$store.state.porCartao;
                if (this.$store.state.tipoCardapio === 'delivery') {
                    
                    /** vamos montar o pedido e salvar no state */
                    const json = this.montarJsonDoPedido();
                    window.localStorage.setItem("pedido", JSON.stringify(json))
                    this.$store.dispatch("setDeliveryPedido", json)
                    this.$router.push({
                        path: '/delivery'
                    });
                } else if (this.$store.state.tipoCardapio === 'balcao') {
                    /** vamos montar o pedido e salvar no state */
                    const json = this.montarJsonDoPedido();
                    window.localStorage.setItem("pedido", JSON.stringify(json))
                    this.$store.dispatch("setDeliveryPedido", json)
                    this.$router.push({
                        path: '/balcao'
                    });
                } else {
                    if (porCartao) {
                        this.pedirNumeroCartao();
                    } else {
                        this.perguntarSeTemCerteza();
                    }
                }
            } 
            
            // caso tenha alergia, nao deixar prosseguir com o pedido. Ao invez, chamar o garcom
            else {
                // console.log("%ccliente com alergia nao ir em frente, chamar garcom!", "color: yellow")
                // let json = {
                //     cnpj: this.$store.state.cnpj,
                //     idTerminal: this.$store.state.idTerminal,
                //     operacao: 11,
                //     NumeroCMS_FK: this.$store.state.mesa,
                //     mesa: this.$store.state.mesa,
                //     tipo: "Cliente com alergia",
                //     IdGarcons_FK: this.$store.state.idgarcom,
                //     CodigoCentroResultado_FK: this.$store.state.codigoCentroResultado,
                //     idCaixaLio: this.$store.state.idTerminal,
                //     numeroEmpresaFK: this.$store.state.numeroEmpresaFK
                // }

                // apiChamarGarcom(json).then((res) => {
                //     console.log(res)
                //     this.loading = false;
                //     Swal.fire({
                //         title: "Aguarde em sua mesa que um garçom virá até você.",
                //         html: '<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50.000000pt" height="50.000000pt" viewBox="0 0 50.000000 50.000000" preserveAspectRatio="xMidYMid meet"> <g transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"> <path d="M45 455 c-50 -49 -15 -135 55 -135 41 0 80 39 80 80 0 41 -39 80 -80 80 -19 0 -40 -9 -55 -25z"/> <path d="M370 371 c-5 -11 -19 -23 -30 -26 -20 -6 -41 -38 -54 -82 -7 -23 -7 -23 104 -23 111 0 111 0 104 23 -13 44 -34 76 -54 82 -11 3 -25 15 -30 26 -6 10 -15 19 -20 19 -5 0 -14 -9 -20 -19z"/> <path d="M7 293 c-4 -3 -7 -66 -7 -140 l0 -133 110 0 110 0 0 62 0 61 23 -21 c13 -12 28 -22 34 -22 6 0 31 24 56 53 27 32 59 58 79 64 30 10 27 11 -37 12 -45 1 -76 -4 -84 -11 -10 -11 -16 -8 -32 12 -48 62 -58 70 -88 70 -29 0 -30 -2 -48 -80 -10 -44 -20 -80 -23 -80 -3 0 -13 36 -23 80 -16 71 -21 80 -41 80 -12 0 -26 -3 -29 -7z"/> </g> </svg>'
                //     })
                // })


                // foi pedido pra nao imprimir mais a alergia (lucca dia 28-05-2025)
                console.log("%ccliente com alergia nao ir em frente, chamar garcom!", "color: yellow")
                
                Swal.fire({
                    title: "Identificamos que você possui alguma alergia alimentar. Por favor, chame um garçom até sua mesa para que possamos garantir sua segurança antes de finalizar o pedido.",
                    html: '<svg version="1.0" xmlns="http://www.w3.org/2000/svg" width="50.000000pt" height="50.000000pt" viewBox="0 0 50.000000 50.000000" preserveAspectRatio="xMidYMid meet"> <g transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none"> <path d="M45 455 c-50 -49 -15 -135 55 -135 41 0 80 39 80 80 0 41 -39 80 -80 80 -19 0 -40 -9 -55 -25z"/> <path d="M370 371 c-5 -11 -19 -23 -30 -26 -20 -6 -41 -38 -54 -82 -7 -23 -7 -23 104 -23 111 0 111 0 104 23 -13 44 -34 76 -54 82 -11 3 -25 15 -30 26 -6 10 -15 19 -20 19 -5 0 -14 -9 -20 -19z"/> <path d="M7 293 c-4 -3 -7 -66 -7 -140 l0 -133 110 0 110 0 0 62 0 61 23 -21 c13 -12 28 -22 34 -22 6 0 31 24 56 53 27 32 59 58 79 64 30 10 27 11 -37 12 -45 1 -76 -4 -84 -11 -10 -11 -16 -8 -32 12 -48 62 -58 70 -88 70 -29 0 -30 -2 -48 -80 -10 -44 -20 -80 -23 -80 -3 0 -13 36 -23 80 -16 71 -21 80 -41 80 -12 0 -26 -3 -29 -7z"/> </g> </svg>'
                })
            
            }
            
        },

        /**
         * Case HardRock, vamos pergunar se o cliente tem alergia e retornar true caso sim.
         */
        async perguntarAlergia() {
            if (this.$store.state.isHardRock == true) {
                return await Swal.fire({
                    title: "Você tem alguma alergia conhecida?",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Não tenho alergia",
                    showCancelButton: true,
                    cancelButtonColor: "green",    
                    allowOutsideClick: false,            
                })
            } else {
                return {isConfirmed: false, isDenied: true, isDismissed: false, value: false};
            }
        },
 
        /** vamos setar habilitarQrcodeScanner para true, mostrando assim a camera para escanear o barcode */
        pedirNumeroCartao() {
            scrollTo(0,0)
            this.habilitarQrcodeScanner = true
            this.$emit('AtualizaStatusBotaoEnviarPedido', true);
        },

        /** vamos confirmar o numero da comanda, e apenas caso o usuario confirme, enviar o pedido */
        onBarcodeLido(val) {
            this.habilitarQrcodeScanner = false
            this.numeroComanda = val
            controleConfirmarNumeroCartao(val)
                .then((res) => {
                    if (res == true) {
                        this.finalizarPedido(val)
                    }
                    else {
                        this.$emit('AtualizaStatusBotaoEnviarPedido', false);
                    }
                })
                .catch((err) => {
                    console.error("Failed to confirm " + err)
                    this.habilitarQrcodeScanner = true
                    this.numeroComanda = null
                })
        },


        /** 
         * mostra um alert perguntando se o usuario tem certeza, e depois da resposta, enviar o pedido 
         */
        perguntarSeTemCerteza() {
            this.$emit('AtualizaStatusBotaoEnviarPedido',true);//bloqueia o botao Enviar pedido
            Swal.fire({
                cancelButtonText: "CANCELAR", 
                showCancelButton: true, 
                showConfirmButton: true,
                title: "Deseja confirmar o pedido?",
                confirmButtonText: "SIM",
                reverseButtons: true,
                buttonsStyling: { width: "50%" }
            }).then((res) => {
                if (res.isConfirmed) {
                    this.finalizarPedido(null);
                }
                else {
                    this.$emit('AtualizaStatusBotaoEnviarPedido', false);
                }
            });
        },

        /**
         * usado apenas para testes
         */
        finalizarPedido22() {
            console.log(this.montarJsonDoPedido())
            CONSOLOGAR[(this.montarJsonDoPedido())];
            CONSOLOGAR[(JSON.stringify(this.montarJsonDoPedido()))];
        },


        /**
         * vai enviar para a api todo o pedido do carrinho
         * ao trazer a resposta, vai chamar a funcao {@link finalizarDepoisDaRespostaChegar()}
         */
        finalizarPedido(numero_cartao) {
            this.loading = true;
            /** 
             * temos que criar essa var self para ser o contexto. La no SWAL.fire, o metodo didClose inicia outro
             * contexto, entao ele nao funcioava usar this.loading = false. Agora, passando a var SELF.loading
             * funciona, pq estamos passando o contexto para frente
             */
            const self = this;

            apiSincronizacao( 
                this.$store.state.cnpj,
                this.$store.state.idTerminal
            ).then((res) => {
                console.log(`res, self, numero_cartao`)
                console.log(res, self, numero_cartao)
                if (res) {

                    /** ver se a mesa nao esta em conta antes de enviar o pedido */
                    apiBuscarStatusMesa(this.$store.state.cnpj, this.$store.state.idTerminal, this.$store.state.numeroEmpresaFK, numero_cartao).then(async (res) => {
                        this.$store.dispatch("setStatusEConta", {statusMesa: res.status, totalContaMesa: res.valor_total});

                        /** se a mesa estiver em conta, exibir erro */
                        if (res.status.toString().toLowerCase() === "conta") {
                            Swal.fire({
                                title: "A conta já foi fechada anteriormente. Não é possível lançar mais itens.",
                                showConfirmButton: false,
                                showCancelButton: true,
                                cancelButtonText: "OK",
                            });
                            this.loading = false;
                            this.$emit('AtualizaStatusBotaoEnviarPedido', false);
                        } else if (res.status.toString().toLowerCase() === "aberta_terminal") {
                            Swal.fire({
                                title: "Comanda aberta em outro terminal. Não é possível lançar mais itens. Por favor, chame um garçom.",
                                showConfirmButton: false,
                                showCancelButton: true,
                                cancelButtonText: "OK",
                            });
                            this.loading = false;
                            this.$emit('AtualizaStatusBotaoEnviarPedido', false);
                        } else if (res.status.toString().toLowerCase() === "bloqueado") {
                            Swal.fire({
                                title: "Seu cartão está bloqueado. Não é possível lançar mais itens.",
                                showConfirmButton: false,
                                showCancelButton: true,
                                cancelButtonText: "OK",
                            });
                            this.loading = false;
                            this.$emit('AtualizaStatusBotaoEnviarPedido', false);
                        } else if (res.status.toString().toLowerCase() === "perdido") {
                            Swal.fire({
                                title: "Esse cartão não pode ser utilizado. Não é possível lançar itens.",
                                showConfirmButton: false,
                                showCancelButton: true,
                                cancelButtonText: "OK",
                            });
                            this.loading = false;
                            this.$emit('AtualizaStatusBotaoEnviarPedido', false);

                        /** caso contrario, enviar o pedido */
                        } else if (res.status.toString().toLowerCase() === "livre" || res.status.toString().toLowerCase() === "aberta") { 
                            const options = {headers: { "Content-Type": "application/json" }};
                            let body = this.montarJsonDoPedido()
                            
                            CONSOLOGAR(["body do pedido", JSON.stringify(body)])

                            console.log(options)
                            const temItemVinculado = await this.checarTemItemVinculado(body)
                            console.log("sera aque tem ? ", temItemVinculado)

                            if (!temItemVinculado) {
                                axios.post(
                                    rotaDeProducao() + "/venda",
                                    body,
                                    options
                                ).then((response) => {
                                    CONSOLOGAR([response.data]);
                                    this.finalizarDepoisDaRespostaChegar(true);
                                }).catch((error) => {
                                    console.log(`%c ta aqui mano ${error}`, "color: yellow")
                                    console.log(error.response)
                                    console.log(Object.keys(error));
                                    CONSOLOGAR([error])

                                    if (error.response.status == 597 || error.response.status == 598 || error.response.status == 599) { // erro da disponibilidade (horavenda) ou da promocao ou da indisponibilidade (estoque)
                                        // vamos mostrar o erro com a mensagem e tbm o segundo param eh pra saber se eh um erro de indisponibilidade
                                        this.exibirErroDePromocaoOuHoraVendaVencidos(error.response.data, error.response.status == 597)
                                    } else if (error.response.status == 593 || error.response.status == 594 || error.response.status == 595 || error.response.status == 596) { // sem licenca ou venda bloqueada no menu estatico
                                        Swal.fire({
                                            title: error.response.data?.mensagem ?? "Este estabelecimento não pode receber pedidos no momento.",
                                            showConfirmButton: false,
                                            showCancelButton: true,
                                            cancelButtonText: "OK",
                                            didClose: () => {
                                                self.loading = false;
                                                this.$emit('AtualizaStatusBotaoEnviarPedido', false);
                                            }
                                        });
                                    } else {
                                        Swal.fire({
                                            title: "Algo deu errado. Por favor, chame um atendente e informe este problema.",
                                            showConfirmButton: false,
                                            showCancelButton: true,
                                            cancelButtonText: "OK",
                                            didClose: () => {
                                                self.loading = false;
                                                this.$emit('AtualizaStatusBotaoEnviarPedido', false);
                                            }
                                        });
                                    }
                                });
                            } else {
                                this.loading = false;
                            }

                                 
                         } else  {
                            Swal.fire({
                                title: "Comanda aberta em outro terminal. Não é possível lançar mais itens. Por favor, chame um garçom.",
                                text: "Terminal: " + res.status,
                                showConfirmButton: false,
                                showCancelButton: true,
                                cancelButtonText: "OK",
                            });
                            this.loading = false;
                            this.$emit('AtualizaStatusBotaoEnviarPedido', false);
                        }
                    }).catch((err) => {
                        CONSOLOGAR([err])
                        this.loading = false;
                        this.$emit('AtualizaStatusBotaoEnviarPedido', false);
                        Swal.fire({
                            title: "Algo deu errado. Por favor, chame um atendente e informe este problema.",
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: "OK",
                        });
                    });
                } else {
                    this.loading = false;
                    this.$emit('AtualizaStatusBotaoEnviarPedido', false);
                    Swal.fire({
                        title: "Não há conexão com o servidor. Por favor, chame um atendente e informe este problema.",
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: "OK",
                    });
                }
            }).catch((e) => {
                console.log("erro de sinc")
                console.log(e)
                Swal.fire({
                    title: "Não há conexão com o servidor. Por favor, chame um atendente e informe este problema.",
                    showConfirmButton: false,
                    showCancelButton: true,
                    cancelButtonText: "OK",
                });
                this.loading = false;
                this.$emit('AtualizaStatusBotaoEnviarPedido', false);
            });
        },


        /**
         * Mostra o erro de promocao ou horavenda
         * @param error {itens : array, mensagem: string}
         */
        exibirErroDePromocaoOuHoraVendaVencidos(error, isIndisponibilidade) {
            console.log("error aqui so olha")
            console.log(error)

            let htmlErro = ""

            htmlErro += "<div>"
            htmlErro += `  <p style='text-align: start;text-indent: 30px;'>${error.mensagem}</p>`
            if(error.codigo_erro===599){htmlErro += `  <p style='text-align: start;text-indent: 30px;'>Você pode adicionar este item novamente com o valor atualizado.</p>`}
            htmlErro += "  <ul style='text-align: start'>"
            error.itens.forEach((e) => {  
                if (isIndisponibilidade) { // caso seja erro de indisponibilidade
                    let dispo = e.qtd_disponivel == 1 ? "disponível" : "disponíveis"
                    htmlErro += `<li style=""><div>${e.nome}</div><div style="font-weight: bold; margin-bottom: 15px">${e.qtd_disponivel} ${dispo}</div></li>`
                    // htmlErro += `<li style="width: 100%; justify-content: space-between; display: flex"><div style="flex: 3">${e.nome}</div><div style="flex: 2">${e.qtd_disponivel} ${dispo}</div></li>`
                } else {
                    htmlErro += `<li>${e.nome}</li>`
                }
            })
            htmlErro += "  </ul>"
            htmlErro += "</div>"

            Swal.fire({
                title: "Ops!",
                html: htmlErro,
                showConfirmButton: false,
                showCancelButton: true,
                cancelButtonText: "OK",
                didClose: () => {
                    self.loading = false;
                    // vamos pegar os ids dos itens para remover do carrinho
                    let itensParaRemover =  error.itens.map((t) => t.id)
                    this.finalizarDepoisDaRespostaChegar(false, itensParaRemover, isIndisponibilidade)
                    this.$emit('AtualizaStatusBotaoEnviarPedido', false);   
                }
            });
        },


        /**
         * Checa os itens vinculados.
         * Retorna true se tiver item vinculado (e dai nao podemos deixar continuar com a venda)
         */
        async checarTemItemVinculado(jsondoPedido) {

            console.log("CHECANDO ITEM VINCULADO")
            console.log(jsondoPedido)

            // chear se algum item tem vinculacao
            const vinculadosDoPedido = jsondoPedido.itens.filter(e => e.item && e.item.codigoItemVendaVinculado_FK && e.item.codigoItemVendaVinculado_FK != 0)
            let vinculadosDoPedidoAqui = vinculadosDoPedido.map((e) =>  ({dependido_id: e.id, dependido_nome: e.nome, codigoItemVendaVinculado_FK: e.item.codigoItemVendaVinculado_FK, item_vinculado_nome: e.item.item_vinculado_nome}))


            let json = {
                cnpj: this.$store.state.cnpj,
                idTerminal: this.$store.state.idTerminal,
                operacao: 2, // operacao de bloqueio
                NumeroCMS_FK:  this.numeroComanda ?? this.$store.state.mesa,
                mesa: this.$store.state.mesa,
                IdGarcons_FK: this.$store.state.idgarcom, 
                CodigoCentroResultado_FK: this.$store.state.codigoCentroResultado,
                idCaixaLio: this.$store.state.idTerminal,
                numeroEmpresaFK: this.$store.state.numeroEmpresaFK,
                tipo: this.numeroComanda ? "cartao" : null,
                cartao: this.numeroComanda || null,
            }
            
            const resposta = await   apiBuscarItensDaConta(json)
            let itemsNecessarios = []
            

            for (let item of vinculadosDoPedidoAqui) {
                const itemigual = resposta.find(test => test.codigoItem == item.codigoItemVendaVinculado_FK)
                if (!itemigual) {
                    console.log("olha so um vinculado aqui")
                    console.log(item)
                    itemsNecessarios.push(item);
                }
            }
            if (itemsNecessarios.length > 0) {
                let html = '<p>Alguns itens escolhidos dependem da compra de outro item. Adicione o item obrigatório para continuar.</p>'
                html+='<ul style="margin-block: 10px">'
                itemsNecessarios.forEach(e => {
                    html += `<li style="margin-bottom: 10px"> <b> ${e.dependido_nome}</b> <span> requer o item: <span> <b>${e.item_vinculado_nome} </b> </li>`
                })
                html+='</ul>'
                Swal.fire({
                    title: "Atenção",
                    html: html,
                })
                return true
            }
            return false           

        },


        /**
         * So inicia quando vem a resposta do backend.
         * vai limpar o cache e dar um alert mostrando que o pedido foi feito.
         * @see finalizarPedido
         */
        async finalizarDepoisDaRespostaChegar(mostarAlertaPedidoFeitoComSucesso, itensParaRemover, isIndisponibilidade) {
            window.localStorage.clear(); // limpar os dados com cache
            console.log('id nesse momento:'+this.$store.state.idUnicoPedido)
            if (mostarAlertaPedidoFeitoComSucesso) {
                this.$store.commit("SET_LIMPAR_ITENS_CARRINHO");
                Swal.fire({
                    title: '<p style="color: #77a; font-family: Arial, Helvetica">Pedido feito com sucesso!<p>',
                        showConfirmButton: true,
                    })
            } else {
                if (isIndisponibilidade != true) 
                this.$store.dispatch("deletarItensCarrinhoPorIds", itensParaRemover);
            }

            let dadosUrl = {
                cnpj: this.$store.state.cnpj,
                idTerminal: this.$store.state.idTerminal,
                isMenuEstatico: this.$store.state.isMenuEstatico,
                isDelivery: this.$store.state.tipoCardapio === 'delivery',
                tipoCardapio: this.$store.state.tipoCardapio,
            };
            

            // vamos buscar todos os itens de novo caso tenha problema de promocao ou disponibilidade
            if (mostarAlertaPedidoFeitoComSucesso==false && (isIndisponibilidade == false || isIndisponibilidade == null || isIndisponibilidade == undefined)) {
                this.$store.dispatch('setAbaSelecionada', "loading")
                await this.$store.dispatch("darRefresh", dadosUrl)
                this.$store.dispatch('setAbaSelecionada', "cardapio")
            } 

            this.loading = false;
            this.mudarParaCardapio()

            // caso nao tenha problema, ainda sim vamos buscar tudo de novo, mas nao precisamos esperar isso terminar
            this.$store.dispatch("darRefresh", dadosUrl).then(() => {});
        },

        /** anima o botao quando o usuario tenta enviar pedido mas o botao esta desabilitado */
        funcaoAnimarTextoDesabilidado() {
            this.animarTextoDesabilidado = true;
            setTimeout(() => {
                this.animarTextoDesabilidado = false;
            }, 1000);
        },
    },
};
</script>

<style scoped>
.icone_do_carrinho{
    padding-block: var(--padding-padrao);
    max-width: 50px;
    animation: andarCarrinho 1.2s ease-out forwards;
}
@keyframes andarCarrinho {
  0% {
    transform: translateX(-150px) rotate(0deg);
  }
  80% {
    transform: translateX(10px) rotate(10deg);
  }
  100% {
    transform: translateX(0) rotate(0deg);
  }
}
.loading {
    margin-top: 120px;
    margin-inline: auto;
}

.carrinho-body {
    background: white;
    height: 100vh;
    overflow-y: hidden;
    padding: 0px;  
    margin: 0;
    animation: carrinho-anim 0.5s forwards;
}
@keyframes carrinho-anim {
    0%  { opacity: 0; scale: 0.9; }
    100%  { opacity: 1; scale: 1;}
}
</style>

